import { get, post } from '@/utils/request1';

export const invoiceDetails = (data) => post('orderw/invoice_details',data); // 订单详情
export const invoiceList = (data) => post('orderw/invoiceList',data); // 发票列表